import * as React from 'react';
import {BaseBlockView} from '../base-block.view';
import {inject, observer} from 'mobx-react';
import {IInjectedProps} from '../../../interface/component/injected-props.interface';
import {VideoBlockModel} from '../../../model/block';
import {youtubeVideoRegEx} from '../../../util/url/is-valid-youtube-url.util';
import {vimeoVideoRegEx} from '../../../util/url/is-valid-vimeo-url.util';
import {VideoBlockTypes} from '../../../enum/block/video-block-types';
import {isLinkEmpty} from '../../../util/url/is-link-empty-url';
import {getLinkFinalURL} from '../../../util/url/get-link-final-url';

@inject('state')
@observer
export class VideoView extends BaseBlockView<VideoBlockModel, IInjectedProps> {
  render() {
    if (this.props.content.type === VideoBlockTypes.Youtube && !isLinkEmpty(this.props.state, this.props.content.youtubeUrl)) {
      const linkURL = getLinkFinalURL(this.props.state, this.props.content.youtubeUrl, undefined, true);
      const match = youtubeVideoRegEx.exec(linkURL);
      youtubeVideoRegEx.lastIndex = 0;
      return (
          <div style={{margin: '0 auto', width: '100%', textAlign: 'center', padding: '20px 0'}}>
            <iframe
                id={`ytplayer-${match[1]}`}
                style={{margin: '0 auto', maxWidth: 640, width: '100%'}}
                width="100%"
                height="360"
                src={`https://www.youtube.com/embed/${match[1]}?autoplay=0&origin=${this.props.state.configuration.CMSUrl}`}
                frameBorder="0"
                allowFullScreen={true}
            />
          </div>
      );
    } else if (this.props.content.type === VideoBlockTypes.Vimeo && !isLinkEmpty(this.props.state, this.props.content.vimeoUrl)) {
      const linkURL = getLinkFinalURL(this.props.state, this.props.content.vimeoUrl, undefined, true);
      const match = vimeoVideoRegEx.exec(linkURL);
      vimeoVideoRegEx.lastIndex = 0;
      return (
          <div style={{margin: '0 auto', width: '100%', textAlign: 'center', padding: '20px 0'}}>
            <iframe
                src={`https://player.vimeo.com/video/${match[1]}?autoplay=0&loop=0&autopause=0`}
                style={{margin: '0 auto', maxWidth: 640, width: '100%'}}
                width="100%"
                height="360"
                frameBorder="0"
                allowFullScreen={true}
            />
          </div>
      );
    }
    if (this.props.inEditor) {
      return <div>Please select a video URL</div>;
    }
    return null;
  }
}
